import { useTranslation } from 'react-i18next';

import { Seo, Div } from 'ui';
import { Hero } from './Hero';

import HowToGetFlixx from './HowToGetFlixx';
import Doubts from './Doubts';


const Index = () => {

  const { t } = useTranslation()

  return (
    <Div
      width='100%'
      overflow='hidden'
      display='flex'
      flexDirection='column'
      alignItems='center'
      paddingTop={70}
      transform='translateY(-70px)'
    >
      <Seo
        title={t('seoFlixxTitle')}
        description={t('seoFlixxDescription')}
      />

      <Hero />
      <HowToGetFlixx />
      <Doubts />
    </Div>
  )
}

export default Index
